import React, { useState, ChangeEvent, FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { REACT_APP_API_BASE_URL } from "../../../environment";

const ForgotPassword2: React.FC = () => {
  const routes = all_routes;
  const navigate = useNavigate();

  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const validateEmail = (email: string): boolean => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  
    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }
  
    setIsLoading(true);
    setError(null);
  
    try {
      const response = await fetch(`${REACT_APP_API_BASE_URL}/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.message || "Something went wrong");
      }
  
      setMessage(data.message);
      navigate(routes.login);
    } catch (err: any) {
      setError("Request failed: " + (err.message || "Unknown error"));
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <div className="container-fuild">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row login-bg-right">
          <div className="col-lg-5">
            <div className="d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100 login-bg-left">
              <div>
                <ImageWithBasePath src="assets/img/bg/auth-page-2.svg" alt="Img" />
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12">
  <div className="row justify-content-center align-items-center vh-100 overflow-auto">
    <div className="col-md-7 mx-auto d-flex flex-column justify-content-center align-items-center vh-100">
      <form onSubmit={handleSubmit} className="w-100">
        <div className="d-flex flex-column align-items-center gap-3 p-4">
          {/* Logo */}
          <div className="text-center">
            <ImageWithBasePath
              src="assets/img/logo.png"
              className="img-fluid"
              alt="Logo"
            />
          </div>

          {/* Content below logo */}
          <div className="w-100">
                      <div className="text-center mb-3">
                        <h2 className="mb-2">Forgot Password?</h2>
                        <p className="mb-0">
                          If you forgot your password, we’ll email you a new password shortly.
                        </p>
                      </div>

                      {message && <div className="alert alert-success">{message}</div>}
                      {error && <div className="alert alert-danger">{error}</div>}

                      <div className="mb-3">
                        <label className="form-label">Email Address</label>
                        <div className="input-group">
                          <input
                            type="email"
                            className="form-control border-end-0"
                            value={email}
                            onChange={handleChange}
                            required
                            disabled={isLoading}
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-mail" />
                          </span>
                        </div>
                      </div>

                      <div className="mb-3">
                        <button type="submit" className="btn btn-pink" disabled={isLoading}>
                          {isLoading ? "Submitting..." : "Submit"}
                        </button>
                      </div>

                      <div className="text-center">
                        <h6 className="fw-normal text-dark mb-0">
                          Return to{" "}
                          <Link to={all_routes.login} className="hover-a">
                            Sign In
                          </Link>
                        </h6>
                      </div>
                    </div>
                    {/* <div className="mt-5 pb-4 text-center">
                      <p className="mb-0 text-gray-9">Copyright © 2025 - Log Binary</p>
                    </div> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword2;
